import { persist, setSerialization, createSessionStorage } from '@macfja/svelte-persistent-store';
import { writable } from 'svelte/store';

setSerialization(JSON.stringify, JSON.parse);

export const ghostToken = persist(writable(null), createSessionStorage(), 'ghostToken');

export const deleteStore = () => {
    ghostToken.delete();
    ghostToken.set(null);
};
